module.exports = __webpack_public_path__ + "img/Gruppenbild.a46a4871.jpg";